module.exports = __webpack_public_path__ + "static/img/cp-bottom.d8d71e70.png";